import Hotspot from "../hotspot";
import Scene from "../scene";


class Move extends Hotspot {
    constructor( targetScene, position = { yaw: 0, pitch: 0 },cameraInitial,customName=null) {
        const hint =customName === null? targetScene.name : customName;
        super({
            content: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
            </svg>`,
            onClick: () => {
                targetScene.loadScene({...cameraInitial,fov:Math.PI/2.2})
            } ,
            className: "next",
            position: position,
            hint:hint,
       
        })
        this.target = targetScene;
        
    }

   

}

export default Move